module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.buyer.email),
      expression: "order.buyer.email"
    }],
    attrs: {
      "type": "text",
      "name": "buyer.email",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.order.buyer.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.order.buyer, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.buyer.phone),
      expression: "order.buyer.phone"
    }],
    attrs: {
      "type": "text",
      "name": "buyer.phone",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.order.buyer.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.order.buyer, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.buyer.firstName),
      expression: "order.buyer.firstName"
    }],
    attrs: {
      "type": "text",
      "name": "buyer.firstName",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.order.buyer.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.order.buyer, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "buyer.language",
      "maxlength": "50",
      "value": "pl"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.description),
      expression: "order.description"
    }],
    attrs: {
      "type": "text",
      "name": "description",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.order.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.order, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.extOrderId),
      expression: "order.extOrderId"
    }],
    attrs: {
      "type": "text",
      "name": "extOrderId",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.order.extOrderId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.order, "extOrderId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.totalAmount),
      expression: "order.totalAmount"
    }],
    attrs: {
      "type": "text",
      "name": "totalAmount",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.order.totalAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.order, "totalAmount", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.language),
      expression: "order.language"
    }],
    attrs: {
      "type": "text",
      "name": "buyer.language",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.order.language)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.order, "language", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.notifyUrl),
      expression: "order.notifyUrl"
    }],
    attrs: {
      "type": "text",
      "name": "notifyUrl",
      "value": ""
    },
    domProps: {
      "value": (_vm.order.notifyUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.order, "notifyUrl", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.customerIp),
      expression: "order.customerIp"
    }],
    attrs: {
      "type": "text",
      "name": "customerIp",
      "maxlength": "25"
    },
    domProps: {
      "value": (_vm.order.customerIp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.order, "customerIp", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.merchantPosId),
      expression: "order.merchantPosId"
    }],
    attrs: {
      "type": "text",
      "name": "merchantPosId",
      "maxlength": "25"
    },
    domProps: {
      "value": (_vm.order.merchantPosId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.order, "merchantPosId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.currencyCode),
      expression: "order.currencyCode"
    }],
    attrs: {
      "type": "text",
      "name": "currencyCode",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.order.currencyCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.order, "currencyCode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.continueUrl),
      expression: "order.continueUrl"
    }],
    attrs: {
      "type": "text",
      "name": "continueUrl"
    },
    domProps: {
      "value": (_vm.order.continueUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.order, "continueUrl", $event.target.value)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0586c691","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PayuForm.vue
// module id = 242
// module chunks = 1